<div class="weekly-hours-page">
  <div class="page-header">
    <div>
      <h1>Relevés d'heures</h1>
      <p class="subtitle">Relevés hebdomadaires générés automatiquement chaque lundi à 9h</p>
    </div>
    <button class="btn-refresh" (click)="load()" [disabled]="loading">
      Rafraîchir
    </button>
  </div>

  @if (loading) {
    <div class="empty-state">Chargement...</div>
  } @else if (reports.length === 0) {
    <div class="empty-state">Aucun relevé disponible pour le moment.</div>
  } @else {
    <div class="reports-table">
      <div class="table-row table-head">
        <div>Établissement</div>
        <div>Semaine</div>
        <div>Période</div>
        <div>Statut</div>
        <div>Actions</div>
      </div>
      @for (r of reports; track r.id) {
        <div class="table-row table-data" (click)="open(r)">
          <div class="etab-name">{{ r.etablissementName }}</div>
          <div>S{{ r.weekNumber }} / {{ r.year }}</div>
          <div class="period">
            {{ r.weekStart | date:'dd/MM/yy' }} → {{ r.weekEnd | date:'dd/MM/yy' }}
          </div>
          <div>
            <span class="status-pill" [class.draft]="r.status === 'DRAFT'"
              [class.ready]="r.status === 'READY'"
              [class.sent]="r.status === 'SENT'">
              {{ statusLabel(r.status) }}
              @if (r.status === 'SENT') { <span>✓</span> }
            </span>
          </div>
          <div class="actions" (click)="$event.stopPropagation()">
            <button class="btn btn-secondary btn-sm" (click)="open(r); $event.stopPropagation()">
              Voir / Éditer
            </button>
            @if (r.canSendNow) {
              <button class="btn btn-primary btn-sm"
                [disabled]="sendingId === r.id"
                (click)="send(r, $event)">
                {{ sendingId === r.id ? 'Envoi...' : 'Envoyer' }}
              </button>
            } @else if (r.status !== 'SENT') {
              <span class="not-yet" [tooltip]="'Disponible à partir du ' + (r.allowedSendFrom | date:'dd/MM HH:mm')">
                ⏳
              </span>
            }
          </div>
        </div>
      }
    </div>
  }
</div>
